import { ObjectUtil } from "../../utils/ObjectUtil";
import { apiAlumnoActualizarFotoPerfil, apiAlumnoObtenerEventos, apiAlumnoObtenerExtemporaneosDisponiblesHoy, apiAlumnoObtenerFoto, apiAlumnoObtenerHorarioHoy, apiAlumnoObtenerInfo, apiAlumnoObtenerLista } from "../API";
import { _APP_DATA } from "../AppData";
import { IAlumno, IApiResult, IEventChild, IInfoChild, ITodaySchoolHour } from "../models/Entities";
import { RequestData } from "../utils/RequestData";
import { _maxChatMessageUpdated } from "./Chat";
import { _SvGrupoClearHorarios } from "./Grupo";
import { EPhotoSize } from "./Photo";
import { _SvTutorClearLocalData } from "./Tutor";

export const _ALUMNOS_MAP: Map<number, IAlumno> = new Map();

/** Map<IdGrupo, Map<IdChild, IAlumno>> */
export const _DICT_GRUPO_ALUMNOS_MAP: Map<number, Map<number, IAlumno>> = new Map();

const mapChildsPositions: Map<number, IAlumno> = new Map(); // FIXME Funciona pero no sigue un estándar
let maxDateChild: string | null = null;

/** Obtiene la lista de alumnos del grupo actual */
export function _SvAlumnoObtenerLista(callback: (res: Array<IAlumno>) => void) {
    _SvAlumnoObtenerListaByGrupo(_APP_DATA.userData.IdGrupo, maxDateChild)
        .then((response) => {
            let resultData: Array<IAlumno> = response?.Datos || [];

            resultData.forEach(item => {
                if (!item.EnUso) {
                    _ALUMNOS_MAP.delete(item.IdChild);
                    return;
                }

                const oldChild = mapChildsPositions.get(item.IdChild);
                if (oldChild) {
                    (item as any).x = (oldChild as any).x; // FIXME PARA NO PERDER LA POSICIÓN DEL ALUMNO EN EL SALÓN
                    (item as any).y = (oldChild as any).y; // FIXME
                }
                _ALUMNOS_MAP.set(item.IdChild, ObjectUtil._GettersSetters(item, {
                    get_NombreCompleto: (dato) => `${dato.Nombre} ${dato.ApPaterno} ${dato.ApMaterno}`.trim(),
                }));
            });

            let maxDate = response?.Maxima;
            if (resultData.length > 0 && maxDate != null)
                maxDateChild = maxDate;

            if (callback) callback(resultData);
        });
}

/** Obtiene la lista de alumnos de un grupo específico */
export function _SvAlumnoObtenerListaByGrupo(idGrupo: number, modificacion: string | null): Promise<IApiResult<IAlumno[]>> {
    const params = {
        "IdGrupo": idGrupo,
        "Modificacion": modificacion
    }
    if (!!idGrupo && !_DICT_GRUPO_ALUMNOS_MAP.has(idGrupo)) {
        _DICT_GRUPO_ALUMNOS_MAP.set(idGrupo, new Map());
    }
    return new Promise<IApiResult<IAlumno[]>>((resolve) => {
        new RequestData<IApiResult<IAlumno[]>>(apiAlumnoObtenerLista)
            .Params(params)
            .Completion((response, error) => {
                if (error) {
                    console.log(error.name, error.message);
                }

                (response?.Datos || []).forEach(item => {
                    item.Nacimiento = new Date(item.Nacimiento);

                    _DICT_GRUPO_ALUMNOS_MAP.get(idGrupo)?.set(item.IdChild, ObjectUtil._GettersSetters(item, {
                        get_NombreCompleto: (dato) => `${dato.Nombre} ${dato.ApPaterno} ${dato.ApMaterno}`.trim(),
                    }));
                });

                resolve(response);
            }).Get();
    });
}

export function _SvAlumnoObtenerHorarioHoy(idChild: number, idGrupo: number, omitirGrupoActual: boolean, callback: (status: number, resul: Array<ITodaySchoolHour>) => void) {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder,
        IdAlumno: idChild,
        IdGrupo: idGrupo || _APP_DATA.userData.IdGrupo,
        OmitirGrupoActual: omitirGrupoActual
    }

    new RequestData<IApiResult<ITodaySchoolHour[]>>(apiAlumnoObtenerHorarioHoy)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            let resultData = response && status > 0 ? response.Datos : [];

            if (error)
                console.log(error.name, error.message);

            resultData.forEach(item => {
                item.Entrada = new Date(item.Entrada);
            });

            if (callback) callback(status, resultData);
        }).Get();
}

export function _SvAlumnoObtenerInfo(idChild: number, callback: (result: IInfoChild | null) => void) {
    let params = {
        IdAlumno: idChild
    }

    new RequestData<IInfoChild>(apiAlumnoObtenerInfo)
        .Params(params)
        .Completion((response, error) => {
            if (error)
                console.log(error.name, error.message);

            let status = response ? response.Resultado : -111;
            let resultData = response;

            if (status < 1) {
                console.log("Ocurrió un error, al descargar infoAlumno");
                resultData = null;
            }

            if (callback) callback(resultData);
        }).Get();
}

export function _SvAlumnoActualizarFotoPerfil(childId: number, image: File, callback: (status: number) => void) {
    let params = {
        IdAlumno: childId,
        IdUsuario: _APP_DATA.userData.IdUsuario,
        Foto: image
    }

    new RequestData<IApiResult<number>>(apiAlumnoActualizarFotoPerfil)
        .Params(params)
        .ExtraInfoInErrorBotMessage(`ImgSize(${image?.size} bytes)`)
        .Completion((response, _) => {
            let status = response ? response.Resultado : -111;

            if (status < 1)
                console.log("Ocurrió un error, al guardar el archivo infoAlumno");

            if (callback) callback(status);
        }).FORM();
}

export function _SvAlumnoObtenerExtemporaneosDisponiblesHoy(callback: (status: number, res: Array<IAlumno>) => void) {
    let params = {
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: null
    }

    new RequestData<IApiResult<IAlumno[]>>(apiAlumnoObtenerExtemporaneosDisponiblesHoy)
        .Params(params)
        .Completion((response, error) => {
            let resultData: Array<IAlumno> = response?.Datos || [];
            const status = response?.Resultado || -111;

            if (error) {
                console.log(error.name, error.message);
                if (callback) callback(status, resultData);
                return;
            }

            resultData.forEach(item => {
                if (item.EnUso === false) {
                    return;
                }

                item.Nacimiento = new Date(item.Nacimiento);
                // item.urlPhoto_ = _URLChildPhoto(item.IdUsuario, EPhotoSize.THUMBNAIL);
            });

            if (callback) callback(status, resultData);
        }).Get();
}

export function _SvAlumnoClearChildsData() {
    _ALUMNOS_MAP.forEach(d => mapChildsPositions.set(d.IdChild, d));
    _ALUMNOS_MAP.clear();
    maxDateChild = null;
    _maxChatMessageUpdated.clear();
    _SvGrupoClearHorarios()
    _SvTutorClearLocalData()
}

export function _SvAlumnoObtenerEventos(childId: number, start: Date, end: Date, callback: (list: Array<IEventChild>, success: boolean) => void): void {
    let params = {
        IdChild: childId,
        Inicio: start.toISOString(),
        Fin: end.toISOString()
    };

    new RequestData<IApiResult<IEventChild[]>>(apiAlumnoObtenerEventos)
        .Params(params)
        .Identifier("_LoadEventByChild")
        .Completion((response, error) => {
            const resultData = response?.Datos || [];
            const success = !error && !!response?.Datos;
            if (error)
                console.log(error.name, error.message);

            resultData.forEach((item) => {
                item.IdChild = childId;
                item.Inicio = item.Inicio ? new Date(item.Inicio) : null;
                item.Fin = item.Fin ? new Date(item.Fin) : null;

                // const child = _ALUMNOS_MAP.get(childId);
                // if (child) {
                //     item.Nombre = child.Nombre;
                //     item.urlPhoto_ = _URLChildPhoto(child.IdUsuario, EPhotoSize.THUMBNAIL);
                //     item.Sexo = child.Sexo;
                // }
            });

            if (callback) callback(resultData, success);
        }).Get();
}

export function _SvAlumnoFotoPerfilURL(alumno: Pick<IAlumno, "IdUsuario" | "Modificacion">, sizePhoto: EPhotoSize): string {
    return apiAlumnoObtenerFoto + `?IdUsuario=${alumno.IdUsuario || 0}&Tamanio=${sizePhoto}&Modificacion=${alumno.Modificacion}`;
}
